import InvoiceIcons from '@/icons/InvoiceIcons'
// import NotificationGrantedIcons from '@/icons/NotificationGrantedIcons'

import BasicInformation from './BasicInformation'
// import SalesProcess from './SalesProcess'
// import MailerConfig from './MailerConfig'
import ContractIcons from '@/icons/ContractIcons'
import EmailIcons from '@/icons/EmailIcons'
import PeopleIcons from '@/icons/PeopleIcons'
import SettingIcons from '@/icons/SettingIcons'
import Contracts from './Contracts'
import InvoicesTab from './InvoicesTab'
import MailerModules from './Mailer'
import ManageSLA from './ManageSLA'
import SaleProcess from './SaleProcess'
import Services from './Services'
import ActivityLogs from './ActivityLogs'
import RevenueAllocation from './RevenueAllocation'
// import Documents from './Documents'
// import FileIcons from '@/icons/FileIcons'
import SLAIcons from '@/icons/SLAIcons'
import { ClipboardList, PieChart } from 'lucide-react'
import { TFunction } from 'i18next'
import { CUSTOMER_STATUS } from '../../constants'

// SLA tab only visible for customers with these statuses
const SLA_ALLOWED_STATUSES = [
    CUSTOMER_STATUS.ACTIVE,
    CUSTOMER_STATUS.TRIAL,
    CUSTOMER_STATUS.STOP, // cancelled/stop customers
]

// Chế độ chỉ xem (viewer_access = lead_origin_readonly): chỉ giữ 2 tab này
export const READ_ONLY_VISIBLE_TABS = ['basic-information', 'sale-process']

export const tabs = (
    t: TFunction,
    customerStatus?: string,
    isReadOnly?: boolean
) => {
    const showSLATab =
        customerStatus && SLA_ALLOWED_STATUSES.includes(customerStatus)

    const baseTabs = [
        {
            label: t('basic-information'),
            value: 'basic-information',
            startIcon: <PeopleIcons />,
            component: <BasicInformation />,
        },
        {
            label: t('sale-process'),
            value: 'sale-process',
            startIcon: <InvoiceIcons />,
            component: <SaleProcess />,
        },
        // {
        //     label: 'mailer-config',
        //     value: 'mailer-config',
        //     startIcon: <NotificationGrantedIcons />,
        //     component: <MailerConfig />,
        // },
        {
            label: t('contracts'),
            value: 'contracts',
            startIcon: <ContractIcons />,
            component: <Contracts />,
        },
        {
            label: t('service'),
            value: 'service',
            startIcon: <SettingIcons />,
            component: <Services />,
        },
        // SLA & Tickets tab - conditionally added based on customer status
        ...(showSLATab
            ? [
                  {
                      label: 'SLA & Tickets',
                      value: 'sla-tickets',
                      startIcon: <SLAIcons />,
                      component: <ManageSLA />,
                  },
              ]
            : []),
        {
            label: t('invoices'),
            value: 'invoices',
            startIcon: <InvoiceIcons />,
            component: <InvoicesTab />,
        },
        {
            label: t('customer-mailers'),
            value: 'mailers',
            startIcon: <EmailIcons />,
            component: <MailerModules.List />,
        },
        {
            label: t('activity_logs.title'),
            value: 'activity-logs',
            startIcon: <ClipboardList className="h-4 w-4" />,
            component: <ActivityLogs />,
        },
        {
            label: t('revenue_allocation'),
            value: 'revenue-allocation',
            startIcon: <PieChart className="h-4 w-4" />,
            component: <RevenueAllocation />,
        },
        // {
        //     label: t('customer-documents'),
        //     value: 'documents',
        //     startIcon: <FileIcons />,
        //     component: <Documents />,
        // },
    ]

    if (!isReadOnly) return baseTabs

    return baseTabs.map((tab) => ({
        ...tab,
        hidden: !READ_ONLY_VISIBLE_TABS.includes(tab.value),
    }))
}
